module.exports = __webpack_public_path__ + "static/media/RevolutionaryChange.c934f326.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/RevolutionaryChange.png
// module id = 74
// module chunks = 0